// Custom error classes for application-specific error handling

export class HttpError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "HttpError";
    this.status = status;

    // This is necessary for instanceof to work correctly with TypeScript
    Object.setPrototypeOf(this, HttpError.prototype);
  }

  isForbidden(): boolean {
    return this.status === 403;
  }

  isNotFound(): boolean {
    return this.status === 404;
  }
}

// Specific error classes for common HTTP errors
export class ForbiddenError extends HttpError {
  constructor(
    message: string = "You don't have permission to access this resource"
  ) {
    super(message, 403);
    this.name = "ForbiddenError";

    Object.setPrototypeOf(this, ForbiddenError.prototype);
  }
}

export class NotFoundError extends HttpError {
  constructor(message: string = "Resource not found") {
    super(message, 404);
    this.name = "NotFoundError";

    Object.setPrototypeOf(this, NotFoundError.prototype);
  }
}
